import { api } from "@/api"

type HandlePasswordResetIn = {
  token: string
  password: string
}

export const resetPassword = async (
  params: HandlePasswordResetIn
) => {
  const { body } = await api.post<{ message: string }>(
    "/auth/handle-password-reset/",
    { body: params, authenticated: false }
  )
  return body
}
